export type KeyName = 'claudeToken' | 'geminiToken' | 'geniusToken';

export const getKey = (name: KeyName): string => {
  try {
    return (localStorage.getItem(name) || '').trim();
  } catch {
    return '';
  }
};
